document.addEventListener('DOMContentLoaded', function() {
  const sliderBlocks = document.querySelectorAll('.cai-review-slider-wide');
  const sliderBlock = sliderBlocks[1];
  sliderBlock.classList.add('second-slider');
  
  const track = sliderBlock.querySelector('.rsw-track');
  const row = sliderBlock.querySelector('.rsw-row');
  const images = row.querySelectorAll('img');
  
    // Wait for all review items to load
    Promise.all(Array.from(images).map(img => {
        return img.complete ? Promise.resolve() : new Promise(resolve => {
            img.addEventListener('load', resolve);
            img.addEventListener('error', resolve);
        });
    })).then(() => {
        // Clone the row and append
        const clone = row.cloneNode(true);
        track.appendChild(clone);
      
        // Set initial position
        let position = 0;
        const startTime = performance.now();
        const speed = 50; // Pixels per second (adjust as needed)
        let animationFrame;
  
        // Get accurate width after layout
        const rowWidth = row.offsetWidth;
  
        function animate(timestamp) {
            const elapsed = timestamp - startTime;
            position = (elapsed / 1000) * speed;
      
            if (position >= rowWidth) {
                position = position % rowWidth;
                track.style.transform = `translateX(-${position}px)`;
                void track.offsetWidth; // Force reflow
            } else {
                track.style.transform = `translateX(-${position}px)`;
            }
            animationFrame = requestAnimationFrame(animate);
        }
  
        // Start animation
        animationFrame = requestAnimationFrame(animate);
  
        // Cleanup on unmount (if needed)
        return () => cancelAnimationFrame(animationFrame);
    });
});